import { Column, Row } from '@/components/styled'
import { Breakpoint, ThemeColor } from '@/enums'
import { themeBreakpointDown, themeColor } from '@/utils'
import styled from 'styled-components'

export const Container = styled.div`
  background-color: ${themeColor(ThemeColor.b0)};
  border: 1px solid ${themeColor(ThemeColor.b30)};
  border-radius: 12px;
  padding: 24px 16px;
`

export const MainCollapseTopContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 12px;
  gap: 24px;
  padding-bottom: 24px;
`

export const ProgressBarContainer = styled(Row)`
  padding: 48px 24px 24px 24px;
  justify-content: center;
`

export const StepContainer = styled(Column)`
  width: 600px;
  height: calc(-74px + 100vh);

  ${themeBreakpointDown(Breakpoint.sm)} {
    width: 100%;
    height: 100%;
  }
`

export const HeaderContainer = styled(Column)`
  gap: 8px;
  padding: 16px 24px;
`

export const FooterContainer = styled(Row)`
  align-items: center;
  padding: 16px 24px 24px 24px;
  border-top: 1px solid ${(props) => props.theme.color.glass200};
`

export const ScrollableContent = styled(Column)`
  flex: 1;
  overflow-y: auto;
  gap: 24px;
  padding: 0 24px 24px 24px;
`

export const FormWrapper = styled(Column)`
  gap: 24px;
  height: 100%;

  > form {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    overflow-y: auto;
  }
`

export const PoaInputsRow = styled(Row)`
  width: 100%;
  gap: 16px;

  > * {
    flex: 1;

    input {
      width: 100%;
    }
  }

  ${themeBreakpointDown(Breakpoint.sm)} {
    flex-direction: column;
    gap: 4px;

    > * {
      width: 100%;
    }
  }
`

export const LoaderImageContainer = styled(Column)`
  img {
    height: 120px;
    width: 120px;
  }
`
